<template>
    <div class="comBasicWrap">
        <div class="comBasicContWrap">
            <!-- 这里写盒子页面 -->
            <div style="display: flex; flex: 1; overflow: hidden;flex-direction:column;height: 100%;">
                <keep-alive>
                    <router-view :ref="componentName" :key="$route.name">
                    </router-view>
                </keep-alive>
            </div>
        </div>
    </div>
</template>

<script>
import comBasic from "@/pages/commonTemp";
import { state, mutations } from "@/store";
// import NavTab from "@/base/frame/index";
import * as menuList from "./menuList";
const fz = Vue.observable({ fontsize: ''})
export default {
    name: "basic",
    components: {
        // NavTab,
        // MenuBox
    },
    provide() {
        return {
            showing: this.onShow,
            fontsizeCache: fz 
        };
    },
    data() {
        return {
            tabs: [], //导航栏
            isMax: false, //是否是全屏
            isShowMenu: false, //是否展示菜单栏
            componentName: "", //组件名称
            activeIndex: -1, //导航栏的下标
            routerMap: {
                iframe: "iframe_box",
                news: "news",
                tags: "tags",
                industry: "industry",
                historic_records: "historic_records",
                single_article: "single_article",
                report: "report",
                notice: "notice",
                view_point: "view_point",
                industry_report: "industry_report",
                broker:"broker"
            },
            // 根据页面类型设置不同的菜单 空串代表不注册菜单
            menuMap: {
                iframe: "",
                news: "menuList1",
                tags: "menuList1",
                broker: "menuList1",
                industry: "menuList1",
                historic_records: "",
                single_article: "",
                report: "",
                notice: "",
                view_point: "",
                industry_report: "menuList1",
            },
            onShow: Vue.observable({ value: false }),
        };
    },
    computed: {
        activeComponent() {
            return state.activeComponent;
        },
        activeRoute() {
            if (this.tabs[this.activeIndex]) {
                return this.tabs[this.activeIndex].componentName;
            } else {
                return "";
            }
        },
    },
    // provide: {
    //     fontsizeCache: fz   
    // },
    inject: ["urlData"],
    beforeCreate: function () { },
    created: function () {
        this.$nextTick((_) => {
            this.registerEmitterListener();
        });
    },
    mounted: function () {
        let item = this.urlData();
        this.addRouter(item);
        this.registerClientNotify();
        this.$client.getCurBrowserDlg(this.updateOnShow);
    },
    watch: {
        activeRoute: {
            handler(newval, oldval) {
                let index = this.activeIndex;
                if (this.tabs[index] && newval) {
                    this.$router.push(`/pages/${this.tabs[index].componentName}`);
                    this.componentName = this.tabs[index].componentName;
                }
            },
            immediate: true,
        },
    },

    methods: {
        registerEmitterListener() {
            this.$on("LISTEN_CHILD", (params) => {
                console.log("params", params);
                // 内部组件更新基本信息
                if (params.method == "freshBaseInfo") {
                    let data = params.data;
                    this.tabs.forEach((element) => {
                        if (element.componentName == data.componentName) {
                            element.title = data.title ? data.title : element.title;
                            element.collectInfo = data.collectInfo
                                ? data.collectInfo
                                : element.collectInfo;
                        }
                    });
                    this.updateTitle(data.title);
                } else if (params.method == "updateFontSize") {
                    this.updateFontSize(params.data);
                } else if (params.method == "changeSkin") {
                    this.changeSkin(params.data);
                } else if (params.method == "collect") {
                    this.collect();
                }
            });
        },
        async registerClientNotify() {
            // 注册回调事件
            this.$client.registerEventNotify((res) => {
                let arr = JSON.parse(res)[0].split("=");
                let key = arr[0];
                console.log("registerEventNotify111", res, key)
                if (key == "skin") {
                    this.changeSkin(arr[1] == "1" ? "night" : "daily");
                } else if (key == "fontsize") {
                    this.$client.setStorageInFile(arr[1]);
                    //this.updateFontSize(arr[1]);
                    fz.fontsize = arr[1];
                    this.updateMenuList(arr[1]);
                } else if (key == "collect") {
                    this.collect();
                } 
            });
            let fontsize;
            try {
                fontsize = await this.$client.getStorageFromFile() || 'medium';
            }catch(e) {
                fontsize = 'medium';
            }
            this.$client.getBrowserDlgSkin().then((res) => {
                if (res == 1) {
                    document.getElementsByTagName("body")[0].className = "night";
                }
            });
            this.updateMenuList(fontsize);
            fz.fontsize = fontsize;
        },
        // 更新菜单
        updateMenuList(fontsize) {
            let menuName = this.menuMap[this.urlData().type];
            menuName
                ? this.$client.setBrowserDlgMenu(menuList[menuName](fontsize))
                : "";
        },
        // 更新窗口标题
        updateTitle(title) {
            if (title) {
                this.$client.setBrowserDlgTabName(title);
                // console.log('this.$client----', this.$client)
            }
        },
        // 更新onShow的状态
        updateOnShow(data) {  
            this.onShow.value = data === 1
        },
        // 调节窗口大小
        changeWindow() {
            if (!this.isMax) {
                this.isMax = true;
                this.$client.viewFullPage();
                this.$broadcast("MESSAGE_TO_CHILD", {
                    method: "changeWindow",
                    data: "fullPage",
                });
            } else {
                this.isMax = false;
                this.$client.viewFullPageCancel();
                this.$broadcast("MESSAGE_TO_CHILD", {
                    method: "changeWindow",
                    data: "cancelViewPage",
                });
            }
        },
        // 全局通知更新字体
        updateFontSize(e) {
            // 客户端连续调用set和get会有bug
            this.$broadcast("MESSAGE_TO_CHILD", {
                method: "changeFontSize",
                data: e,
            });
        },
        // 全局通知皮肤更新
        changeSkin(e) {
            document.getElementsByTagName("body")[0].className = e;
            this.$broadcast("MESSAGE_TO_CHILD", {
                method: "changeSkin",
                data: e,
            });
        },
        // 收藏
        collect() {
            console.log("收藏本篇资讯");
            // this.$sendPoint("sc");
            let collectInfo = this.tabs[this.activeIndex].collectInfo;
            if (!collectInfo) {
                this.$client.showBrowserDlgTip({ text: "当前资讯不可收藏!" });
            }

            const stock = collectInfo.artstock.length ? collectInfo.artstock.join(',') : this.tabs[this.activeIndex]['code']

            this.$http.addCollect
                .call(this, {
                    title: collectInfo.title,
                    data: collectInfo.summary,
                    sourceId: 7,
                    url: collectInfo.weburl,
                    stock: stock,
                })
                .then((res) => {
                    this.$client.showBrowserDlgTip({ text: res.msg });
                });
        },
        // 添加路由
        addRouter(item = {}) {
            // 这段基本没动过，估计是浏览记录的需求；2020年底这期这个功能不上线
            if (Object.keys(item).length && item.type == "historic_records") {
                let index = this.tabs.findIndex((k) => {
                    return k.type == item.type;
                });
                if (index !== -1) {
                    this.activeIndex = index;
                    return;
                }
            }
            this.componentName = "page" + state.componentIndex;
            let routerMap = this.routerMap;
            let data = item;
            data.componentName = this.componentName;
            if (!item.hasOwnProperty("title")) {
                data.title = "调试标题";
            }

            // alert(routerMap[item.type]);

            // this.$router.addRoutes([
            //     {
            //         path: "/pages",
            //         name: "comBasic",
            //         component: comBasic,
            //         children: [
            //             {
            //                 path: this.componentName,
            //                 name: this.componentName,
            //                 props: () => ({ model: { ...item } }),
            //                 component: () =>
            //                     import(
            //                         /* webpackChunkName: "page" */ `@/pages/${routerMap[item.type]
            //                         }`
            //                     ),
            //             },
            //         ],
            //     },
            // ]);

            // alert(routerMap[item.type]);
            console.log("this", this);
            console.log("item", item);
            // debugger
            if (item.type == undefined) {
                console.log(`url中不存在type，默认使用news类型`);
                item.type = 'news'
            }

            // 配置文件在router/index.js里
            this.$router.addRoutes([
                {
                    path: "/pages",
                    name: "comBasic",
                    component: comBasic,
                    children: [
                        {
                            path: this.componentName,
                            name: this.componentName,
                            props: () => ({ model: { ...item } }),
                            component: () =>
                                import(
                                    /* webpackChunkName: "page" */ `@/pages/${routerMap[item.type]
                                    }`
                                ),
                        },
                    ],
                },
            ]);

            let list = this.tabs.concat([]);
            list.push(data);
            this.tabs = list;
            this.activeIndex = this.tabs.length - 1;
            mutations.setComponentIndex(1 + state.componentIndex);
            let comlist = state.activeComponent;
            comlist.push(this.componentName);
            mutations.setActiveComponent(comlist);
        },
    },
};
</script>

<style lang="less" scoped>
@import '../../common/style/index.less';
.comBasicWrap {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .comBasicContWrap {
        height: 100%;
        display: flex;
        flex-direction: column;
    }
}
.flex-row {
    display: flex;
}
</style>
